<svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#a)">
        <path
            stroke="currentColor" stroke-width="1.199"
            d="M6.496 13.242a5.746 5.746 0 1 0 0-11.493 5.746 5.746 0 0 0 0 11.493Z" />
        <path
            stroke="currentColor" stroke-linecap="round" stroke-width="1.299"
            d="M6.496 6.496v3.998" />
        <path fill="currentColor" d="M6.497 5.448a.7.7 0 1 0 0-1.4.7.7 0 0 0 0 1.4Z" />
    </g>
    <defs>
        <clipPath id="a">
            <path fill="#fff" d="M0 1h12.992v12.992H0z" />
        </clipPath>
    </defs>
</svg>
